import { Injectable } from '@angular/core';
import { LazyLoadEvent } from "../../models/DataTables/lazyLoadEvent";
import { EditNotificationContentTypeViewModel, INotificationContentType } from "../../models/inModels/NotificationContentType";
import { AuthenticationService } from "../authentication/authentication.service";
import { LoggingService } from "../logging/logging.service";
import { HttpClient } from '@angular/common/http';
import { SendMessageModel } from "../../models/inModels/MessageModel";

@Injectable()
export class NotificationTypeService {
	private routeCategory = '/api/notification/types';
	constructor(
		private http: HttpClient,
		private auth: AuthenticationService,
		private logging: LoggingService) { }

	search(event: LazyLoadEvent): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/search`, JSON.stringify(event), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	get(id: number): Promise<INotificationContentType> {
		return this.http.get(`${this.auth.apiUrl}${this.routeCategory}/get/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response as INotificationContentType)
			.catch(error => this.logging.handleError(error));
	}

	update(user: EditNotificationContentTypeViewModel): Promise<INotificationContentType> {
		return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/update`, JSON.stringify(user), { headers: this.auth.header })
			.toPromise()
			.then(response => response as INotificationContentType)
			.catch(error => this.logging.handleError(error));
	}

}



// WEBPACK FOOTER //
// ./src/app/services/notifications/notification.service.ts